// ./src/components/Frame/index.js

import Frame from './Frame.vue';

export default Frame;
